export enum RecipientError {
  required,
  invalidEmail,
  exists,
  domain,
}
